const unificationPaths = {
	UNIFY_PASSWORD: "/unificar-senha",
	UPDATE_PHONE: "/atualizar-contato/telefone",
};

export default unificationPaths;
